import { ReactElement, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "base/hooks/useAuth";
import Loader from "base/components/Loader";

interface Props {
  children: ReactElement;
}

const AuthGuard = ({ children }: Props) => {
  const navigate = useNavigate();
  const { isLoggedIn, isLoading } = useAuth();

  useEffect(() => {
    // Redirecting before the check resolves would bounce valid sessions to /login on first render.
    if (!isLoading && !isLoggedIn) {
      navigate("login", { replace: true });
    }
  }, [isLoggedIn, isLoading]);

  if (isLoading) {
    return <Loader type="page" isFullPage />;
  }

  // Avoid flashing protected content while the redirect above runs.
  if (!isLoggedIn) {
    return null;
  }

  return children;
};

export default AuthGuard;
